import React, { useRef } from 'react';

import { Heading } from './components/Heading';
import { RulesSwitch } from './components/RulesSwitch';
import { Rules } from './components/Rules';
import * as s from './RealtorRatingHeader.css';

/**
 * Шапка рейтинга риелторов
 */
export const RealtorRatingHeader = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <div className={s['wrapper']}>
      <div className={s['heading-wrapper']}>
        <Heading />
        <RulesSwitch ref={ref} />
      </div>

      <div className={s['rules-wrapper']}>
        <Rules ref={ref} />
      </div>
    </div>
  );
};
